export default __webpack_public_path__ + "static/media/bi_coin.12e02d6b.svg";